import apiClient from './client';
import type {
    Project,
    ProjectWithDomains,
    CreateProjectInput,
    UpdateProjectInput,
    ProjectUser,
    AddUserToProjectInput
} from '@/types/project.ts';

// ========== PROJECTS API ==========

// Listar todos os projetos do usuário autenticado
export const getProjects = async (): Promise<Project[]> => {
    const response = await apiClient.get<Project[]>('/projects');
    return response.data;
};

// Obter projeto específico com seus domínios
export const getProjectById = async (projectId: number): Promise<ProjectWithDomains> => {
    const response = await apiClient.get<ProjectWithDomains>(`/projects/${projectId}`);
    return response.data;
};

// Criar novo projeto
export const createProject = async (data: CreateProjectInput): Promise<Project> => {
    const response = await apiClient.post<Project>('/projects', data);
    return response.data;
};

// Atualizar projeto
export const updateProject = async (projectId: number, data: UpdateProjectInput): Promise<Project> => {
    const response = await apiClient.put<Project>(`/projects/${projectId}`, data);
    return response.data;
};

// Deletar projeto (soft delete)
export const deleteProject = async (projectId: number): Promise<void> => {
    await apiClient.delete(`/projects/${projectId}`);
};

// ========== PROJECT USERS API ==========

// Listar usuários do projeto
export const getProjectUsers = async (projectId: number): Promise<ProjectUser[]> => {
    const response = await apiClient.get<ProjectUser[]>(`/projects/${projectId}/users`);
    return response.data;
};

// Adicionar usuário ao projeto
export const addUserToProject = async (projectId: number, data: AddUserToProjectInput): Promise<void> => {
    await apiClient.post(`/projects/${projectId}/users`, data);
};

// Remover usuário do projeto
export const removeUserFromProject = async (projectId: number, userId: number): Promise<void> => {
    await apiClient.delete(`/projects/${projectId}/users/${userId}`);
};